import axios from "axios";
import { ApiClient } from "./ApiClient";

class AWSClient extends ApiClient {
  async s3Upload(url: string, binaryFile: File, contentType: string) {
    return axios.create().put(url, binaryFile, {
      transformRequest: (data, headers) => {
        delete headers.Authorization;
        delete headers.common;
        return data;
      },
      headers: {
        "Cache-Control": "no-cache",
        "Content-Type": contentType,
        Accept: "*/*",
      },
    });
  }
}

export default AWSClient;
